import { render, staticRenderFns } from "./UsuariosAdminCRUD.vue?vue&type=template&id=206d8068"
import script from "./UsuariosAdminCRUD.vue?vue&type=script&lang=js"
export * from "./UsuariosAdminCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports